import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchFilesetPreviewById } from '../../actions/data';
import { storeWithExpiration } from '../../utils/common';
import FilesetPreviewTable from './FilesetPreviewTable';

export class FilesetPreviewTableContainer extends React.Component {
  static propTypes = {
    datasetId: PropTypes.string.isRequired,
    fetchFilesetPreviewByIdAction: PropTypes.func.isRequired,
    fileset: PropTypes.object.isRequired,
    filesetPreviewSummary: PropTypes.object.isRequired,
    progress: PropTypes.number.isRequired,
    version: PropTypes.number,
  };

  static defaultProps = {
    version: undefined,
  };

  state = {
    isLoaded: false,
  };

  componentWillMount = () => {
    const { datasetId, fetchFilesetPreviewByIdAction, fileset, version } = this.props;
    const token = storeWithExpiration.get('token');

    fetchFilesetPreviewByIdAction(token, parseInt(datasetId, 10), fileset.id, version);
  };

  componentWillReceiveProps = nextProps => {
    const { progress } = nextProps;
    const isLoaded = progress < 1;
    this.setState({
      isLoaded,
    });
  };

  render() {
    const { isLoaded } = this.state;
    const { fileset, filesetPreviewSummary } = this.props;
    const filesetPreview = filesetPreviewSummary.get(fileset.id);

    return isLoaded && filesetPreview !== undefined ? (
      <FilesetPreviewTable
        key={fileset.id}
        filesetId={fileset.id}
        filesetPreview={filesetPreview}
      />
    ) : null;
  }
}

const mapStateToProps = state => {
  const { data, progress } = state;
  const filesetPreviewSummary = data.get('filesetPreviewSummary');
  return { filesetPreviewSummary, progress };
};

export default connect(mapStateToProps, {
  fetchFilesetPreviewByIdAction: fetchFilesetPreviewById,
})(FilesetPreviewTableContainer);
